import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../../types/Product';
import { truncateText, formatPrice } from '../../utils/formatters';

interface ProductCardProps {
  product: Product;
  className?: string;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, className = '' }) => {
  const { id, name, description, image, price, featured, new: isNew } = product;
  
  return (
    <Link 
      to={`/izdelek/${id}`}
      className={`bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 card-glow flex flex-col h-full ${className}`}
    >
      <div className="relative">
        <img 
          src={image || '/images/placeholder-product.jpg'} 
          alt={name} 
          className="w-full h-64 object-cover"
          width={400}
          height={400}
        />
        
        {/* Badges */}
        <div className="absolute top-4 left-4 flex flex-col gap-2">
          {featured && (
            <span className="bg-secondary text-white text-xs font-bold px-3 py-1 rounded-full">
              Najbolj priljubljen
            </span>
          )}
          {isNew && (
            <span className="bg-primary text-white text-xs font-bold px-3 py-1 rounded-full">
              Novo
            </span>
          )}
        </div>
      </div>
      
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-xl font-semibold mb-2 text-primary-700 h-14">{name}</h3>
        
        <p className="text-gray-600 mb-4 flex-grow">
          {truncateText(description, 100)}
        </p>
        
        <div className="mt-auto">
          {price && (
            <span className="font-bold text-lg text-primary-800 block">
              {formatPrice(price)}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;